import { createStore } from 'zustand/vanilla';
import { useStore } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';

type EditorState = {
  newStepId?: string;
  setNewStepId: (id?: string) => void;
};

export const editorStore = createStore<EditorState>()(
  devtools(
    subscribeWithSelector((set) => ({
      newStepId: undefined,
      setNewStepId: (id) => set({ newStepId: id }),
    })),
    { name: 'editor-state', enabled: import.meta.env.DEV },
  ),
);

export const useEditorState = <T>(selector: (s: EditorState) => T) =>
  useStore(editorStore, selector);
